import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6034289e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "header bg_box" }
const _hoisted_4 = { class: "header_right" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "head_r_text" }, "观看页显示", -1))
const _hoisted_6 = { class: "center" }
const _hoisted_7 = {
  key: 0,
  class: "center_auto"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "hover_box" }
const _hoisted_10 = { class: "item_text" }
const _hoisted_11 = { class: "item_title" }
const _hoisted_12 = {
  key: 0,
  class: "item_titles"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "footer bg_box" }
const _hoisted_15 = {
  key: 0,
  class: "fit_panel"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开启后：文档将在自定义菜单栏区域显示；关闭后：默认为悬浮显示；", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开启后默认主屏显示文档", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开启后用户不能自由切换窗口", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "panel_title" }, "文档翻页延时设置", -1))
const _hoisted_20 = { class: "panel_num" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = {
  key: 0,
  class: "right"
}
const _hoisted_23 = {
  class: "right_box",
  style: {"height":"calc(100% - 48px)"}
}
const _hoisted_24 = { class: "item_box" }
const _hoisted_25 = {
  class: "custom-slick-arrow",
  style: {"left":"10px","z-index":"1"}
}
const _hoisted_26 = {
  class: "custom-slick-arrow",
  style: {"right":"10px"}
}
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "item_but" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击弹出，观看页将强制弹出文档窗口", -1))
const _hoisted_30 = {
  key: 1,
  class: "right"
}
const _hoisted_31 = { class: "modal_body" }
const _hoisted_32 = { class: "page_mar" }
const _hoisted_33 = { class: "modal_footer" }
const _hoisted_34 = { class: "modal_footer_box" }
const _hoisted_35 = { class: "modal_footer_pos" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "previe_body" }
const _hoisted_38 = ["src"]

import { computed, nextTick, onMounted, onUnmounted, reactive, ref, unref, watch } from 'vue';
import {
  PlusCircleOutlined,
  SettingOutlined,
  QuestionCircleFilled,
  LeftCircleFilled,
  RightCircleFilled,
  LoadingOutlined,
} from '@ant-design/icons-vue';
import { Key } from 'ant-design-vue/lib/_util/type';
import {
  Table,
  Modal,
  Switch,
  InputNumber,
  Select,
  Carousel,
  Popover,
  Button,
  Checkbox,
  Input,
  message,
  Pagination,
  Upload,
} from 'ant-design-vue';
import CDelModal from '@/components/CDelModal.vue';
import { emptyDataSec } from '@/assets';
import http from '@/api';
import router from '@/router';
import { DataType, FileInfo, DocumentData } from './liveMode';
import { getToken } from '@/plugins/cookie';
import { useConsoleStore } from '@/pinia/console';
import EventBus from '@/components/EventBus';
import { useDebounce } from '@/hooks/useDebounce'; //防抖


export default /*#__PURE__*/_defineComponent({
  __name: 'FileLive',
  setup(__props) {

const token = getToken();
const studioId = router.currentRoute.value.params.studioId;
const aTable = Table;
const aModal = Modal;
const aSwitch = Switch;
const aInputNumber = InputNumber;
const aCarousel = Carousel;
const aPopover = Popover;
const aButton = Button;
const aCheckbox = Checkbox;
const aInputSearch = Input.Search;
const aSelect = Select;
const aPagination = Pagination;
const aUpload = Upload;

// S上传文档 显示
const visible = ref<boolean>(false);
// 分页
const pageConfigure = reactive({
  current: 1, // 当前页
  pageSize: 5, // 每页条数
  totalSize: 5, // 总数
});
// 上传文档
const fileList = ref([]);
const fileStatus = ref();
const handleChange = (info: FileInfo) => {
  fileStatus.value = info.file.status;
  if (info.file?.response?.code === 200) {
    message.success(info.file?.response.message);
    getMediaList();
  } else if (info.file?.response?.code === 100) {
    message.error(info.file.response?.error);
  }
};
//  添加文档 到 文档列表
const addMediaList = (file: any, ppt: string, imageIds: any) => {
  const index = file.name.lastIndexOf('.');
  const type = file.name.substring(index + 1);
  const computer_type = ref();
  if (type === 'pdf' || type === 'pdfx') {
    computer_type.value = 0;
  }
  if (type === 'ppt' || type === 'pptx') {
    computer_type.value = 1;
  }
  if (type === 'doc' || type === 'docx') {
    computer_type.value = 2;
  }
  if (type === 'xls' || type === 'xlsx') {
    computer_type.value = 3;
  }
};
const columns = [
  {
    title: '文档名称',
    dataIndex: 'computer_name',
    align: 'center',
    ellipsis: true,
  },
  {
    title: '上传日期',
    dataIndex: 'created_at',
    align: 'center',
  },
  {
    title: '页数',
    dataIndex: 'number',
    align: 'center',
  },
  {
    title: '预览',
    align: 'center',
    slots: { customRender: 'preview' },
  },
];
// 获取 上传文档  文档列表
const fileData = ref<DataType[]>([]);
const getMediaList = () => {
  selectedRowKeys.value.length = 0;
  visible.value = true;
  const data = {
    page: pageConfigure.current,
    page_num: pageConfigure.pageSize,
    keywords: state.value.valueSearch,
    computer_type: '',
  };
  http.liveMode.getMediaList({ params: data }).then((res) => {
    if (res.data.data.data) {
      fileData.value = res.data.data.data;
    }
    pageConfigure.totalSize = res.data.data.total;
  });
};
// 预览对话框显示
const previewModal = ref(false);
const previewTitle = ref(); // 预览 文件 名称
const imageContent = ref(); // 预览文件 集合
const previewStatus = ref(); // 转码成功与否 状态
const previewChange = (record: any) => {
  previewTitle.value = record.computer_name;
  imageContent.value = record.image_urls;
  previewStatus.value = record.status;
  previewModal.value = true;
};
// const fileData: DataType[] = [];
// for (let i = 0; i < 5; i += 1) {
//   fileData.push({
//     key: i,
//     name: `文档名称 ${i}`,
//     time: '2021-04-16 19:48',
//     page: 23,
//   });
// }
const selectedRowKeys = ref<Key[]>([]);
const onSelectChange = (changableRowKeys: Key[]) => {
  selectedRowKeys.value = changableRowKeys;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
    fixed: false,
  };
});
// 选择 文档 添加到 左侧列表
const moveMediaFile = () => {
  const data = {
    document_id: selectedRowKeys.value.join(','),
    studio_id: studioId,
  };
  http.liveMode
    .moveMediaFile(data)
    .then((res) => {
      visible.value = false;
      loadpageSize.value = 1;
      documentList.value = [];
      getDocumentList(1);
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
// 观看页开关  0不允许 1允许
const displayDis = ref(false);
const setWanchDisplay = () => {
  displayDis.value = true;
  const data = {
    studio_id: studioId,
    display: state.value.display ? 1 : 0,
  };
  http.liveMode
    .setWanchDisplay(data)
    .catch(() => {
      message.warning('网络异常,请稍后重试！');
    })
    .finally(() => (displayDis.value = false));
};
const documentList = ref<DocumentData[]>([]); // 文档列表
const swiperList = ref<any[]>([]); // 轮播图列表
const state = ref({
  display: false, //观看页显示
  menuDisplay: false, // 设置菜单
  turnPage: false, // 允许翻页
  download: false, // 允许下载
  forceHomeScreen: false, // 主屏显示
  lockView: false, // 锁定视图
  pcDelay: 0, //电脑端延时
  mobileDelay: 0, //手机端延时
  valueSearch: '', // 搜索框
  selectValue: '', //选择分页
  documentId: 0, //翻页文档id
  delDocumentId: 0, // 删除文档索引
  documentTotal: 0, //文档列表总数
  documentIndex: 0, // 正在使用文档翻页索引
  pageIndex: 0, // 轮播图索引
});
//   获取 文档直播 列表
const lastPage = ref(); //最后一页数据
const loadpageSize = ref(1); // 第几页数据
const noMore = ref(false); //判断是否有更多数据
const getDocumentList = (current: any) => {
  const data = {
    studio_id: studioId,
    page: current,
    page_num: 9,
  };
  http.liveMode.getDocumentList({ params: data }).then((res) => {
    res.data.data.display ? (state.value.display = true) : (state.value.display = false); // 观看页显示
    res.data.data.menu_display ? (state.value.menuDisplay = true) : (state.value.menuDisplay = false); //菜单
    res.data.data.turn_page ? (state.value.turnPage = true) : (state.value.turnPage = false); //翻页
    res.data.data.download ? (state.value.download = true) : (state.value.download = false); //下载
    res.data.data.force_home_screen ? (state.value.forceHomeScreen = true) : (state.value.forceHomeScreen = false); //主屏
    res.data.data.switch_view ? (state.value.lockView = true) : (state.value.lockView = false); // 锁定视图
    state.value.pcDelay = res.data.data.pc_delay; //电脑端延时
    state.value.mobileDelay = res.data.data.mobile_delay; //手机端延时
    state.value.documentTotal = res.data.data.document_list.total; //文档列表总数
    res.data.data.document_list.data ? documentList.value.push(...res.data.data.document_list.data) : [];
    res.data.data.document_list.last_page ? (lastPage.value = res.data.data.document_list.last_page) : [];
    documentList.value.forEach((item) => {
      if (item.status === 1 && item.image_urls) {
        swiperList.value = item.image_urls;
        state.value.documentId = item.document_id;
        state.value.documentIndex = Number(item.page_index) + 1;
        state.value.pageIndex = Number(item.page_index);
      }
    });
    state.value.selectValue = `${state.value.documentIndex}/${swiperList.value.length}`;
  });
};
getDocumentList(1);
//滚动加载数据
const getChildList = () => {
  if (loadpageSize.value < lastPage.value) {
    noMore.value = false;
    loadpageSize.value++;
    getDocumentList(loadpageSize.value);
  } else {
    noMore.value = true;
  }
};
//  使用文档
const useDisabled = ref(false);
const monitorId = useConsoleStore();
const useDocment = (item: any) => {
  message.destroy();
  useDisabled.value = true;
  state.value.documentId = item.document_id;
  if (item.status === 1) {
    // 1 使用文档 0取消使用文档
    const data = {
      studio_id: studioId,
      document_id: item.document_id,
      monitor_id: monitorId.consoleInfo.monitorId,
      status: 0,
    };
    http.liveMode
      .useDocment(data)
      .then((res) => {
        message.success(res.data.message);
        documentList.value.forEach((item) => {
          item.status = 0;
        });
        state.value.pageIndex = 0;
        selectPage(0);
        swiperList.value = [];
      })
      .catch((err) => {
        message.error(err.data.error);
      })
      .finally(() => (useDisabled.value = false));
  } else {
    // swiperList.value = [];
    const data = {
      studio_id: studioId,
      document_id: item.document_id,
      monitor_id: monitorId.consoleInfo.monitorId,
      status: 1,
    };
    http.liveMode
      .useDocment(data)
      .then((res) => {
        message.success(res.data.message);
        documentList.value.forEach((item) => {
          item.status = 0;
        });
        item.status = 1;
        nextTick(() => {
          swiperList.value = item.image_urls;
        });
      })
      .catch((err) => {
        message.error(err.data.error);
      })
      .finally(() => (useDisabled.value = false));
  }
};
// wss
const getUseDocumentation = (data: any) => {
  state.value.documentId = data.document_id;
  state.value.documentIndex = Number(data.page_index) + 1;
  state.value.pageIndex = Number(data.page_index);
  documentList.value.forEach((e) => {
    if (e.document_id == data.document_id && e.image_urls) {
      e.status = 1;
      swiperList.value = [];
      nextTick(() => {
        swiperList.value = e.image_urls;
        state.value.selectValue = `${state.value.documentIndex}/${swiperList.value.length}`;
      });
    } else e.status = 0;
  });
};
// watch(wssDocumentId, (nav) => {
//   swiperList.value = [];
//   documentList.value.forEach((e) => {
//     if (e.document_id == nav && e.image_urls) {
//       e.status = 1;
//       swiperList.value = e.image_urls;
//       console.log('wss');
//       state.value.selectValue = `${state.value.documentIndex}/${swiperList.value.length}`;
//     } else e.status = 0;
//   });
// });
// watch(wssPageIndex, () => {
//   if (wssPageIndex.value) {
//     state.value.documentIndex = Number(wssPageIndex.value) + 1;
//     state.value.pageIndex = Number(wssPageIndex.value);
//   }
//   state.value.selectValue = `${state.value.documentIndex}/${swiperList.value.length}`;
// });
EventBus.on('consoleUsageDocumentation', getUseDocumentation);
onUnmounted(() => {
  EventBus.off('consoleUsageDocumentation', getUseDocumentation);
});
// 删除文档
const delFile = ref(false);
const showDelModal = (id: number) => {
  state.value.delDocumentId = id;
  delFile.value = !delFile.value;
};
const delDocument = () => {
  const data = {
    studio_id: studioId,
    document_id: state.value.delDocumentId,
  };
  http.liveMode
    .delDocument({ params: data })
    .then(() => {
      message.success('删除成功！');
      delFile.value = false;
      loadpageSize.value = 1;
      documentList.value = [];
      getDocumentList(1);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
//  文档设置面板
const setUp = ref(false);
const showPanel = () => {
  setUp.value = !setUp.value;
};
const modeSetRef = ref();
const exit = (e: MouseEvent) => {
  if (!modeSetRef.value.contains(e.target) && setUp.value) {
    setUp.value = false;
  }
};
onMounted(() => {
  document.addEventListener('click', exit);
});
onUnmounted(() => {
  document.removeEventListener('click', exit);
});
// 设置才菜单显示
const setMenu = () => {
  const data = {
    studio_id: studioId,
    menu_display: state.value.menuDisplay ? 1 : 0,
  };
  http.liveMode.setMenu(data).catch((err) => {
    message.error(err.data.error);
  });
};
// 允许观众翻页
const setTurnPage = () => {
  const data = {
    studio_id: studioId,
    turn_page: state.value.turnPage ? 1 : 0,
  };
  http.liveMode.setTurnPage(data).catch((err) => {
    message.error(err.data.error);
  });
};
// 允许观众下载
const setDownload = () => {
  const data = {
    studio_id: studioId,
    download: state.value.download ? 1 : 0,
  };
  http.liveMode.setDownload(data).catch((err) => {
    message.error(err.data.error);
  });
};
// 主屏显示
const setMianScreen = () => {
  const data = {
    studio_id: studioId,
    force_home_screen: state.value.forceHomeScreen ? 1 : 0,
  };
  http.liveMode.setMianScreen(data).catch((err) => {
    message.error(err.data.error);
  });
};
// 锁定视图
const setLockView = () => {
  const data = {
    studio_id: studioId,
    switch_view: state.value.lockView ? 1 : 0,
  };
  http.liveMode.setLockView(data).catch((err) => {
    message.error(err.data.error);
  });
};
const carouselRef = ref();
const selectPage = (current: number) => {
  carouselRef.value.goTo(current);
};
// 文档翻页
const setDocmentPage = (current: number) => {
  state.value.documentIndex = current + 1;
  state.value.selectValue = `${state.value.documentIndex}/${swiperList.value.length}`;
  const data = {
    studio_id: studioId,
    document_id: state.value.documentId,
    index: current,
    document_image_url: swiperList.value[current],
    monitor_id: monitorId.consoleInfo.monitorId,
    token: token,
  };
  http.liveMode.setDocmentPage(data).catch((err) => {
    message.error(err.data.error);
  });
};
// 文档翻页延时
const setPageDelay = () => {
  const data = {
    studio_id: studioId,
    pc_delay: state.value.pcDelay,
    mobile_delay: state.value.mobileDelay,
  };
  http.liveMode.setPageDelay(data).catch((err) => {
    message.error(err.data.error);
  });
};
// 弹出
const setEject = () => {
  const data = {
    studio_id: studioId,
  };
  http.liveMode.setEject(data).then((res) => {
    message.success(res.data.message);
  });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, "文档（" + _toDisplayString(state.value.documentTotal) + "）", 1),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(aSwitch), {
              checked: state.value.display,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((state.value.display) = $event)),
              disabled: displayDis.value,
              onChange: setWanchDisplay,
              "checked-children": "开",
              "un-checked-children": "关"
            }, null, 8, ["checked", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (documentList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(aButton), {
                  type: "link",
                  class: "center_auto_but",
                  onClick: getMediaList
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("上传文档")
                  ]),
                  _: 1
                }),
                _createTextVNode("  添加 ")
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentList.value, (item, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["list_item", { actived: item.status === 1 }])
            }, [
              _createElementVNode("div", {
                class: "list_item_left",
                onClick: ($event: any) => (useDocment(item))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(aButton), {
                    type: "link",
                    class: "hover_box_but",
                    disabled: useDisabled.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.status ? '取消使用' : '使用文件'), 1)
                    ]),
                    _: 2
                  }, 1032, ["disabled"])
                ]),
                _createVNode(_component_svg_icon, { "icon-class": "but_ppt_img" }),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.computer_name), 1),
                  (item.status)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "使用中..."))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_8),
              _withDirectives(_createElementVNode("div", {
                class: "list_item_right",
                onClick: ($event: any) => (showDelModal(item.id))
              }, [
                _createVNode(_component_svg_icon, {
                  "icon-class": "but_ppt_del",
                  class: "del_blue"
                }),
                _createVNode(_component_svg_icon, {
                  "icon-class": "but_ppt_delred",
                  class: "del_red"
                })
              ], 8, _hoisted_13), [
                [_vShow, !item.status]
              ])
            ], 2)), [
              [_directive_infinite_scroll, getChildList]
            ])
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(aButton), {
            type: "text",
            class: "footer_l",
            onClick: getMediaList
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(PlusCircleOutlined)),
              _createTextVNode("上传文档")
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            ref_key: "modeSetRef",
            ref: modeSetRef,
            style: {"position":"relative","width":"50%"}
          }, [
            _createVNode(_unref(aButton), {
              type: "text",
              class: _normalizeClass(["footer_r", { actived: setUp.value === true }]),
              onClick: showPanel
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SettingOutlined)),
                _createTextVNode("文档设置 ")
              ]),
              _: 1
            }, 8, ["class"]),
            (setUp.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_unref(aCheckbox), {
                    checked: state.value.menuDisplay,
                    "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((state.value.menuDisplay) = $event)),
                    onChange: setMenu
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 设置菜单显示   "),
                      _createVNode(_unref(aPopover), { placement: "right" }, {
                        content: _withCtx(() => [
                          _hoisted_16
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(QuestionCircleFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_unref(aCheckbox), {
                    checked: state.value.turnPage,
                    "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((state.value.turnPage) = $event)),
                    onChange: setTurnPage
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("允许观众翻页")
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_unref(aCheckbox), {
                    checked: state.value.download,
                    "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => ((state.value.download) = $event)),
                    onChange: setDownload
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("允许观众下载")
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_unref(aCheckbox), {
                    checked: state.value.forceHomeScreen,
                    "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((state.value.forceHomeScreen) = $event)),
                    onChange: setMianScreen
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 主屏显示   "),
                      _createVNode(_unref(aPopover), { placement: "right" }, {
                        content: _withCtx(() => [
                          _hoisted_17
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(QuestionCircleFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_unref(aCheckbox), {
                    checked: state.value.lockView,
                    "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((state.value.lockView) = $event)),
                    onChange: setLockView
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 锁定视图   "),
                      _createVNode(_unref(aPopover), { placement: "right" }, {
                        content: _withCtx(() => [
                          _hoisted_18
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_unref(QuestionCircleFilled))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createTextVNode(" 电脑端延时："),
                    _createVNode(_unref(aInputNumber), {
                      id: "inputNumber",
                      value: state.value.pcDelay,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((state.value.pcDelay) = $event)),
                      min: 0,
                      max: 60,
                      onChange: setPageDelay
                    }, null, 8, ["value"]),
                    _createTextVNode("  秒 "),
                    _hoisted_21,
                    _createTextVNode(" 手机端延时："),
                    _createVNode(_unref(aInputNumber), {
                      id: "inputNumber",
                      value: state.value.mobileDelay,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((state.value.mobileDelay) = $event)),
                      min: 0,
                      max: 60,
                      onChange: setPageDelay
                    }, null, 8, ["value"]),
                    _createTextVNode("  秒 ")
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 512)
        ])
      ]),
      (swiperList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_unref(aCarousel), {
                  ref_key: "carouselRef",
                  ref: carouselRef,
                  arrows: "",
                  dots: false,
                  "after-change": setDocmentPage,
                  initialSlide: state.value.pageIndex
                }, {
                  prevArrow: _withCtx(() => [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_unref(LeftCircleFilled))
                    ])
                  ]),
                  nextArrow: _withCtx(() => [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_unref(RightCircleFilled))
                    ])
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(swiperList.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "arrow_img_box"
                      }, [
                        _createElementVNode("img", {
                          src: item,
                          class: "arrow_img",
                          alt: ""
                        }, null, 8, _hoisted_27)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["initialSlide"])
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_unref(aSelect), {
                value: state.value.selectValue,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((state.value.selectValue) = $event)),
                class: "but_sel",
                onChange: selectPage
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(swiperList.value, (item, index) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, { key: index }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(index + 1) + "/" + _toDisplayString(swiperList.value.length), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"]),
              (state.value.display)
                ? (_openBlock(), _createBlock(_unref(aButton), {
                    key: 0,
                    type: "primary",
                    size: "small",
                    class: "but_but",
                    onClick: setEject
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("弹出")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(aPopover), { placement: "top" }, {
                content: _withCtx(() => [
                  _hoisted_29
                ]),
                default: _withCtx(() => [
                  (state.value.display)
                    ? (_openBlock(), _createBlock(_unref(QuestionCircleFilled), { key: 0 }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createVNode(_component_a_empty, {
              class: "null_img",
              image: _unref(emptyDataSec),
              description: "页面暂无数据信息~"
            }, null, 8, ["image"])
          ]))
    ]),
    _createVNode(_unref(aModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((visible).value = $event)),
      width: "800px",
      title: "添加文档",
      centered: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createTextVNode(" 没有合适的文档？ "),
              _createVNode(_unref(aUpload), {
                "file-list": fileList.value,
                "onUpdate:fileList": _cache[12] || (_cache[12] = ($event: any) => ((fileList).value = $event)),
                name: "file",
                accept: ".ppt,.pptx,.pdf",
                multiple: true,
                action: "/api/v1/tc_cos/tc_upload",
                showUploadList: false,
                headers: { token: _unref(token) },
                onChange: _cache[13] || (_cache[13] = (info) => handleChange(info)),
                class: "upload"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("上传文档")
                ]),
                _: 1
              }, 8, ["file-list", "headers"]),
              (fileStatus.value === 'uploading')
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                    _createTextVNode(" "),
                    _createVNode(_unref(LoadingOutlined), { class: "par_color" }),
                    _createTextVNode(" 文件上传中...")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_unref(aButton), {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (visible.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_unref(aButton), {
            type: "primary",
            onClick: moveMediaFile
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_unref(aInputSearch), {
              value: state.value.valueSearch,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((state.value.valueSearch) = $event)),
              size: "small",
              placeholder: "请输入文档名称",
              style: {"width":"160px"},
              onChange: getMediaList
            }, null, 8, ["value"]),
            _createElementVNode("span", null, "已选文档：" + _toDisplayString(selectedRowKeys.value.length), 1)
          ]),
          _createVNode(_unref(aTable), {
            columns: columns,
            "data-source": fileData.value,
            "row-selection": _unref(rowSelection),
            "row-key": "id",
            pagination: false,
            class: "t_body"
          }, {
            preview: _withCtx(({ record }) => [
              _createVNode(_unref(aButton), {
                type: "link",
                onClick: ($event: any) => (previewChange(record))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "but_preview" })
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["data-source", "row-selection"]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_unref(aPagination), {
              total: pageConfigure.totalSize,
              current: pageConfigure.current,
              "onUpdate:current": _cache[10] || (_cache[10] = ($event: any) => ((pageConfigure.current) = $event)),
              "page-size": pageConfigure.pageSize,
              "onUpdate:pageSize": _cache[11] || (_cache[11] = ($event: any) => ((pageConfigure.pageSize) = $event)),
              "show-less-items": "",
              onShowSizeChange: getMediaList,
              onChange: getMediaList
            }, null, 8, ["total", "current", "page-size"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: previewModal.value,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((previewModal).value = $event)),
      width: "700px",
      centered: "",
      title: previewTitle.value,
      footer: null
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          (previewStatus.value === '转码中')
            ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
                key: 0,
                class: "loading"
              }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(imageContent.value, (item, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: index,
                  src: item
                }, null, 8, _hoisted_38))
              }), 128))
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(CDelModal, {
      visible: delFile.value,
      centered: "",
      close: showDelModal,
      ok: delDocument
    }, null, 8, ["visible"])
  ], 64))
}
}

})